var _circle, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSecurityAssessments(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 82,
    height: 82,
    viewBox: "0 0 82 82",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 41,
    cy: 41,
    r: 40.5,
    stroke: "#2F80ED"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M81 41C81 63.0914 63.0914 81 41 81C18.9086 81 1 63.0914 1 41C1 18.9086 18.9086 1 41 1C63.0914 1 81 18.9086 81 41ZM6.2 41C6.2 60.2195 21.7805 75.8 41 75.8C60.2195 75.8 75.8 60.2195 75.8 41C75.8 21.7805 60.2195 6.2 41 6.2C21.7805 6.2 6.2 21.7805 6.2 41Z",
    fill: "#2F80ED",
    fillOpacity: 0.4
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.3333 56V54.3333H35.9467L36.7083 51H44.3333V49.3333H25.1667C23.7883 49.3333 22.6667 48.2117 22.6667 46.8333V46H44.3333V44.3333H22.6667V28.5C22.6667 27.1217 23.7883 26 25.1667 26H56.8333C58.2117 26 59.3333 27.1217 59.3333 28.5V37.6667H61V28.5C61 26.2017 59.13 24.3333 56.8333 24.3333H25.1667C22.87 24.3333 21 26.2017 21 28.5V46.8333C21 49.1317 22.87 51 25.1667 51H34.9983L33.855 56H44.3333ZM59.3333 44.3333V43.5C59.3333 40.2833 56.7167 37.6667 53.5 37.6667C50.2833 37.6667 47.6667 40.2833 47.6667 43.5V44.3333H46V59.3333H61V44.3333H59.3333ZM49.3333 43.5C49.3333 41.2017 51.2033 39.3333 53.5 39.3333C55.7967 39.3333 57.6667 41.2017 57.6667 43.5V44.3333H49.3333V43.5ZM47.6667 46V57.6667H59.3333V46H47.6667ZM54.3333 54.3333V49.3333H52.6667V54.3333H54.3333Z",
    fill: "#141413"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSecurityAssessments);
export default __webpack_public_path__ + "static/media/security_assessments.584a65b524c34c24a904ae9de34e2de8.svg";
export { ForwardRef as ReactComponent };